<p-panel
  [toggleable]="true"
  [(collapsed)]="collapsed"
  toggler="header"
  [attr.data-testid]="'system-recording-non-hr-panel'"
>
  <ng-template #header>
    <div class="flex items-center justify-between w-full gap-6">
      <div class="flex items-center gap-2">
        <span class="text-lg font-medium">
          {{ 'project.steps.systemRecording.nonHrSystems.title' | transloco }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  @if (!collapsed()) {
    <div class="space-y-3" [class.relative]="isSaving()">
      @if (isLoading()) {
        <app-loading [size]="LoadingSize.SMALL" />
      } @else {
        @if (isSaving()) {
          <div class="absolute inset-0 justify-center">
            <app-loading [size]="LoadingSize.MIDDLE" />
          </div>
        }

        <div [class.opacity-50]="isSaving()" [class.pointer-events-none]="isSaving()">
          @if (entries().length === 0) {
            <div class="flex flex-col items-center justify-center py-8 gap-4">
              <p class="text-secondary">
                {{ 'project.steps.systemRecording.nonHrSystems.noEntries' | transloco }}
              </p>
              <p-button
                icon="pi pi-plus"
                [label]="'project.steps.systemRecording.nonHrSystems.addEntry' | transloco"
                severity="secondary"
                (onClick)="onAddEntry()"
                [disabled]="isReadOnly()"
              />
            </div>
          } @else {
            <div
              class="hidden lg:flex items-center gap-2 w-full min-w-0 px-2 text-sm text-secondary uppercase"
            >
              <div class="flex-1 grid grid-cols-4 gap-2 min-w-0 w-full">
                <span>{{
                  'project.steps.systemRecording.nonHrSystems.header.system' | transloco
                }}</span>
                <span>{{
                  'project.steps.systemRecording.nonHrSystems.header.provider' | transloco
                }}</span>
                <span>{{
                  'project.steps.systemRecording.nonHrSystems.header.tool' | transloco
                }}</span>
                <span>{{
                  'project.steps.systemRecording.nonHrSystems.header.offices' | transloco
                }}</span>
              </div>
              <div class="w-20 shrink-0"></div>
            </div>

            @for (entry of entries(); track entry.id) {
              <div
                class="p-2 mb-3 bg-third-level rounded-sm flex flex-wrap xl:flex-nowrap items-center gap-2 w-full min-w-0"
              >
                <div
                  class="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 min-w-0 w-full"
                >
                  <div class="w-full min-w-0">
                    <app-model-field-select
                      [id]="'non-hr-system-' + entry.id"
                      [options]="nonHrSystemsResource.value() ?? []"
                      placeholder="project.steps.systemRecording.nonHrSystems.systemPlaceholder"
                      [value]="entry.systemDirectusId"
                      (valueChange)="onEntryChange(entry.id, {systemDirectusId: $event})"
                      [disabled]="isReadOnly()"
                    />
                  </div>
                  <div class="w-full min-w-0">
                    <input
                      type="text"
                      pInputText
                      class="w-full"
                      [ngModel]="entry.provider"
                      (ngModelChange)="onEntryChange(entry.id, {provider: $event})"
                      [disabled]="isReadOnly()"
                      [placeholder]="
                        'project.steps.systemRecording.nonHrSystems.providerPlaceholder' | transloco
                      "
                    />
                  </div>
                  <div class="w-full min-w-0">
                    <input
                      type="text"
                      pInputText
                      class="w-full"
                      [ngModel]="entry.tool"
                      (ngModelChange)="onEntryChange(entry.id, {tool: $event})"
                      [disabled]="isReadOnly()"
                      [placeholder]="
                        'project.steps.systemRecording.nonHrSystems.toolPlaceholder' | transloco
                      "
                    />
                  </div>
                  <div class="w-full min-w-0">
                    <app-office-multi-select
                      [projectId]="projectId()"
                      [selectedOffices]="entry.officeIds"
                      [isReadOnly]="isReadOnly()"
                      (selectionChange)="onEntryChange(entry.id, {officeIds: $event})"
                    />
                  </div>
                </div>
                <div class="w-20 shrink-0 flex items-center justify-end gap-2">
                  <p-button
                    icon="pi pi-plus"
                    severity="secondary"
                    size="small"
                    (onClick)="onAddEntry()"
                    [disabled]="isSaving() || isReadOnly()"
                  />
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    size="small"
                    (onClick)="onRemoveEntry(entry.id)"
                    [disabled]="isSaving() || isReadOnly()"
                  />
                </div>
              </div>
            }
          }

          @if (hasChanges()) {
            <div class="flex justify-end mt-4">
              <app-project-step-save-button
                (clicked)="saveModule()"
                [disabled]="!areEntriesValid() || isSaving()"
              />
            </div>
          }
        </div>
      }
    </div>
  }
</p-panel>
